import React from 'react'

// Styles
import "./Map.scss"

const Map = () => <div id='Map'></div>

export default Map